import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Investor  from '../components/investor/investor_body';

const Page = () => {
  return (
    <div>
      <title>投資專區</title>
      <Topbar />
      <Navbar />
      {/* <Carousel /> */}
      <Investor  />
    </div>
  );
};

export default Page;